@if (!enterpriseService.hideForEnterprise()) {
  <header class="header">
    <a routerLink="/" class="header-brand">
      <img *ngIf="whitelabelService.isApplicationWhitelabelLoaded" [src]="whitelabelService.whitelabel?.pdf_logo_mini" alt="" />
    </a>
    <div class="header-navigation">
      <div routerLinkActive="tab">
        <a routerLink="/documentos" class="header-navigation-item" routerLinkActive="selected" [attr.data-name]="translateService.instant('menu.documents')">
          <i class="fa-regular fa-file-alt"></i>
        </a>
      </div>
      <div routerLinkActive="tab">
        <a routerLink="/pastas" class="header-navigation-item" routerLinkActive="selected" [attr.data-name]="translateService.instant('menu.folders')">
          <i class="fa-regular fa-folder"></i>
        </a>
      </div>
      <div routerLinkActive="tab">
        <a routerLink="/contatos" class="header-navigation-item" routerLinkActive="selected" [attr.data-name]="translateService.instant('menu.contacts')">
          <i class="fa-regular fa-book-user"></i>
        </a>
      </div>
      <div routerLinkActive="tab">
        <a
          [routerLink]="'/perfil/' + (urlParamsService.params.configPath || '')"
          class="header-navigation-item"
          routerLinkActive="selected"
          [attr.data-name]="translateService.instant('menu.settings')"
        >
          <i class="fa-regular fa-cog"></i>
        </a>
      </div>
    </div>
    <div>
      @if (currentUser?.locale?.language === 'pt-BR' && appService.isAutentiqueDomain()) {
        <a href="javascript:void(0)" class="header-navigation-item" [attr.data-name]="translateService.instant('menu.roadmap')" app-nolt>
          <i class="fa-regular fa-lightbulb-on"></i>
        </a>
      }

      @if (!whitelabelService.isWhitelabel() && !appService.isInsideIframe()) {
        <a (click)="openChat()" href="javascript:void(0)" class="header-navigation-item open-intercom" [attr.data-name]="translateService.instant('menu.intercom')">
          <i class="fa-regular fa-comments-question"></i>
        </a>
      }
    </div>

    <app-verifications-credits-count *ngIf="currentUser" [user]="currentUser" class="mb-2"></app-verifications-credits-count>
    <app-documents-count *ngIf="currentUser" [user]="currentUser" class="mb-3"></app-documents-count>
    @if (currentUser) {
      <div class="header__account" placement="right-bottom" [sameSizeSubmenus]="true" (mouseover)="dropdown.open()" appDropdown>
        <app-avatar [seed]="currentUser?.email || currentUser?.name || currentUser?.phone" appDropdownAnchor></app-avatar>
        <div aria-labelledby="header__account-avatar" class="header__account-modal" appDropdownMenu>
          <div class="header__account-user">
            @if (currentUser?.name) {
              <p class="header__account-user-name">{{ currentUser?.name }}</p>
            }
            @if (currentUser?.email) {
              <p class="header__account-user-contact">{{ currentUser?.email }}</p>
            } @else if (currentUser?.phone) {
              <p class="header__account-user-contact">{{ currentUser?.phone }}</p>
            }
          </div>
          <hr class="header__account-hr" />
          <p class="header__account-title">{{ 'menu.currentOrganization' | translate }}</p>
          @if (!appService.isEnterpriseChild) {
            <a href="javascript:void(0)" class="header__account-user dropdown__item--descriptive" appDropdownItem submenuToggle="submenu1">
              <div>
                <p class="header__account-user-company">{{ currentUser.organization?.id ? currentUser.organization.name : ('menu.noOrganization' | translate) }}</p>
                <span class="header__account-user role" [ngClass]="{ premium: userService.isSubscriptionPaid(currentUser) }">{{ userService.getSubscriptionName(currentUser) }}</span>
              </div>
            </a>
          }
          <hr class="dropdown-divider" />
          <label class="dropdown__item-switch">
            <span>{{ 'menu.darkMode' | translate }}</span>
            <app-switch [(ngModel)]="appService.isDarkmode"></app-switch>
          </label>
          <hr class="dropdown-divider" />
          <a [routerLink]="'/perfil/' + (urlParamsService.params.configPath || '')" class="dropdown__item--font-weight-700" appDropdownItem>
            <i class="fa-regular fa-cog"></i>
            {{ 'menu.settings' | translate }}
          </a>
          <button type="button" class="dropdown__item--font-weight-700" app-nolt appDropdownItem>
            <i class="fa-regular fa-lightbulb-on"></i>
            {{ 'menu.featureRequests' | translate }}
          </button>
          <a routerLink="/documentos/lixeira" class="dropdown__item--font-weight-700" appDropdownItem>
            <i class="fa-regular fa-trash"></i>
            {{ 'menu.trash' | translate }}
          </a>
          <hr class="dropdown-divider" />

          <button type="button" class="dropdown__item--danger dropdown__item--font-weight-700" (click)="logout()" appDropdownItem>
            <i class="fa-regular fa-sign-out"></i>
            {{ 'auth.signOut' | translate }}
          </button>
        </div>

        <div appDropdownSubmenu="submenu1">
          <button class="button__back" type="button" appDropdownBackButton>{{ 'button.back' | translate }}</button>
          <hr class="header__account-hr" />
          <div class="header__account-options">
            <p class="header__account-title">{{ 'menu.organizations' | translate }}</p>
            @for (organization of organizations; track organization.id) {
              <a href="javascript:void(0)" class="header__account-option" (click)="selectDefaultOrganization(organization.id)" appDropdownItem>
                <p class="header__account-option-text">{{ organization.name }}</p>
                <p class="header__account-option-text-id">
                  <span class="role" [ngClass]="{ premium: isSubscriptionPaid(organization) }">{{ organization.subscription.name | translate }}</span>
                  <span>{{ organization.uuid }}</span>
                </p>
              </a>
            }
          </div>
          <hr class="header__account-hr" />
          <div class="header__account-options-bottom">
            <a href="javascript:void(0)" class="header__account-option" (click)="openCreateOrganizationModal()" appDropdownItem>
              <span class="header__account-option-text">{{ 'menu.newOrganization' | translate }}</span>
            </a>
          </div>
        </div>
      </div>
    }
  </header>
}
